export default {
    path: 'monthlybill',
    component: () => import(/* webpackChunkName: "common-list" */ '@/pages/common/CommonList'),
    meta: {title:'月度账单'}
}